export const SAVE = 'rentalVehicleExcessSCTIStep.SAVE';
export const VALUE_CHANGED = 'rentalVehicleExcessSCTIStep.VALUE_CHANGED';
export const LOAD = 'rentalVehicleExcessSCTIStep.VALUE_LOAD';
export const NEXT = 'rentalVehicleExcessSCTIStep.NEXT';
export const RESET = 'rentalVehicleExcessSCTIStep.RESET';
//--------------------------------------------------------
export const RESET_RENTAL_VEHICLE_EXCESS_STATE = 'rentalVehicleExcessSCTIStep.RESET_RENTAL_VEHICLE_EXCESS_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.RentalVehicleExcess/constants.js